import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import type { ReactNode, RefObject } from 'react';

/** Menu mobile modal : le focus reste dans le panneau et revient à son bouton d'ouverture. */
export function NavigationDrawer({ open, onOpenChange, title, closeLabel, returnFocusRef, children }: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  closeLabel: string;
  returnFocusRef: RefObject<HTMLButtonElement | null>;
  children: ReactNode;
}) {
  return <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
    <RadixDialog.Portal>
      <RadixDialog.Overlay className="fixed inset-0 z-40 bg-black/50 md:hidden" />
      <RadixDialog.Content
        aria-describedby={undefined}
        className="fixed inset-y-0 left-0 z-50 flex w-60 max-w-[85vw] flex-col border-r border-white/10 bg-brand text-white shadow-xl outline-none md:hidden"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          // À la transition vers le bureau, le bouton mobile disparaît ; ne pas lui rendre le focus.
          if (!window.matchMedia?.('(min-width: 768px)').matches) returnFocusRef.current?.focus();
        }}
      >
        <div className="flex h-[72px] shrink-0 items-center justify-between border-b border-white/10 px-5">
          <RadixDialog.Title className="flex min-w-0 items-center gap-3 truncate font-heading text-lg font-semibold"><span className="h-6 w-1 shrink-0 rounded-full bg-accent" aria-hidden />{title}</RadixDialog.Title>
          <RadixDialog.Close className="rounded-md p-2 hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label={closeLabel}>
            <X size={18} aria-hidden />
          </RadixDialog.Close>
        </div>
        {children}
      </RadixDialog.Content>
    </RadixDialog.Portal>
  </RadixDialog.Root>;
}
